import getConfig from 'src/utils/getConfig';
import { APPROVED_AGENCY_STATUSES } from 'src/constants/agency';

export const isAgencyApproved = agencyStatus => {
  const approvedAgencyStatuses = getConfig(
    'applicationMode.agent_portal.onboarding.approved_statuses',
    APPROVED_AGENCY_STATUSES,
  );

  return approvedAgencyStatuses.includes(agencyStatus);
};
